import { render, staticRenderFns } from "./PieceJointe.vue?vue&type=template&id=120a0598&scoped=true"
import script from "./PieceJointe.vue?vue&type=script&lang=js"
export * from "./PieceJointe.vue?vue&type=script&lang=js"
import style0 from "./PieceJointe.vue?vue&type=style&index=0&id=120a0598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a0598",
  null
  
)

export default component.exports